
//  live
// export const api = "https://api.neta.co.in/graphql";

//  stagging
export const api = "https://api-neta.deepsense.dev/graphql";

//testing 1
// export const api = "https://vij.in.ngrok.io/graphql"
// export const api = "https://7ea4f079ad35.ngrok.io/graphql"

export const Razorpay_Key = "rzp_live_VbQ3eFzFw01mUL";
//rzp_test_C53tVXlremTw3Q ashok
// rzp_test_z0KmJfc665D4iN vijay
// rzp_test_6Oe8wDVMElsoLo old staging
// rzp_live_VbQ3eFzFw01mUL live

export const assetUrl ="https://neta.sgp1.cdn.digitaloceanspaces.com/Live/front/"

export const profit_color = "#0AC09E";
export const loss_color = "#FF5C5C";
